
class GlassElement {
    constructor({
      width,
      height,
      radius,
      depth,
      blur = 2,
      chromaticAberration = 0,
      strength = 100,
      debug = false
    }) {
      this.width = width;
      this.height = height;
      this.baseDepth = depth;
      this.blur = blur;
      this.chromaticAberration = chromaticAberration;
      this.strength = strength;
      this.debug = debug;
      this.clicked = false;
      
      // Detect iOS/Android - SVG filters don't work on mobile
      const ua = navigator.userAgent;
      this.isMobile = /iPad|iPhone|iPod/.test(ua) || /android/i.test(ua) || 
                      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      
      this.element = this.createElement();
      this.setupEventListeners();
      this.updateStyle();
    }
    createElement() {
      const div = document.createElement('div');
      div.className = 'glass-element';
      return div;
    }
    setupEventListeners() {
      this.element.addEventListener('mousedown', () => {
        this.clicked = true;
        this.updateStyle();
      });
  
      this.element.addEventListener('mouseup', () => {
        this.clicked = false;
        this.updateStyle();
      });
  
    
      this.element.addEventListener('mouseleave', () => {
        this.clicked = false;
        this.updateStyle();
      });
    }
    updateStyle() {
      // Change element depth on click
      const depth = this.baseDepth / (this.clicked ? 0.7 : 1);
  
      // Set basic dimensions and border radius
      this.element.style.height = `${this.height}px`;
      this.element.style.width = this.width;
      this.element.style.borderRadius = `${this.radius}px`;
  
      // Debug mode: display the displacement map instead of actual effect
      if (this.debug) {
        const displacementMap = getDisplacementMap({
          height: this.height,
          width: this.width,
          radius: this.radius,
          depth: depth
        });
        this.element.style.background = `url("${displacementMap}")`;
        this.element.style.boxShadow = "none";
        this.element.style.backdropFilter = "none";
      } else {
        if (this.isMobile) {
          // iOS/Android: Simple blur effect only (increased blur for mobile)
          const blurFilter = `blur(${this.blur * 10}px) brightness(1.1) saturate(1.5)`;
          this.element.style.webkitBackdropFilter = blurFilter;
          this.element.style.backdropFilter = blurFilter;
          this.element.style.background = "rgba(255, 255, 255, 0.1)";
        } else {
          // Chrome/Edge desktop: Full displacement effect
          const displacementFilter = getDisplacementFilter({
            height: this.height,
            width: this.width,
            radius: this.radius,
            depth: depth,
            strength: this.strength,
            chromaticAberration: this.chromaticAberration
          });
          this.element.style.backdropFilter = `blur(${this.blur / 3}px) url('${displacementFilter}') blur(${this.blur}px) brightness(1.1) saturate(1.5)`;
          this.element.style.background = "rgba(255, 255, 255, 0.1)";
        }
      }
    }
    appendTo(parent) {
      parent.appendChild(this.element);
    }
  } 